import { CANDIDAT_TY_URL_PATTERN } from '../config.js';
import { buildAmplitudeIdentifyCall } from '../identify/amplitude-builder.js';
import { amplitudeIdentify } from '../services/amplitude.js';
import { logger } from '../utils/logger.js';

/**
 * Vrai si l'URL courante est la thank you page candidat.
 */
export function isCandidatPage(pathname: string = window.location.pathname): boolean {
  return pathname.includes(CANDIDAT_TY_URL_PATTERN);
}

/**
 * Sur la page /contact/redirection-candidat, pousse un identify Amplitude
 * enrichi de la user property `candidat = "Oui"` (setOnce).
 *
 * - No-op si pas sur la page candidat
 * - Amplitude uniquement (pas de HubSpot — géré par workflow HS natif)
 * - One-shot : pas de persistence dans le cookie taleez_tracking
 */
export function handleCandidatPage(): void {
  if (!isCandidatPage()) return;

  logger.info('Page redirection candidat détectée:', window.location.pathname);

  if (!window.amplitude) {
    logger.warn('Amplitude pas chargé sur la page candidat');
    return;
  }

  const identify = buildAmplitudeIdentifyCall();
  //identify.setOnce('candidat', 'Oui');
  logger.info('Amplitude prop candidat=Oui ajoutée (setOnce)');
  amplitudeIdentify(identify);
}
